import axios from 'axios';
import {API_BASE_URL, LOCATION_KEY} from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import {message, notification} from 'antd';

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000
})

service.interceptors.request.use(config => {
	const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

	if (jwtToken) {
		config.headers = {
			...((config.headers) ?? {}),
			Authorization: `Bearer ${jwtToken}`,
		}
	}

  	return config
}, error => {
	notification.error({
		message: 'Error'
	})

	Promise.reject(error)
})

service.interceptors.response.use( (response) => {
	return response.data
}, (error) => {

	let notificationParam = {
		content: error.response.data.message ?? "Une erreur est survenue"
	}

	if (error.response.status === 401) {
		notificationParam.content = error.response.data.message ?? 'Votre session à expiré, veuillez vous reconnecter'
		localStorage.removeItem(LOCATION_KEY);
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}

	if (error.response.status === 403) {
		notificationParam.content = error.response.data.message ?? "Vous n'avez pas les droits nécessaires pour effectuer cette action"
	}

	if (error.response.status === 404) {
		notificationParam.content = 'Ressource non trouvée'
	}

	if (error.response.status === 500) {
		notificationParam.content = 'Une erreur est survenue'
	}
	
	if (error.response.status === 508) {
		notificationParam.content = 'Délai d\'attente dépassé'
	}

	message.error({
		...notificationParam,
		duration: 5
	})

	return Promise.reject(error);
});

export default service